export const fetchSection = async (
  node: HTMLElement,
  searchParams: URLSearchParams,
) => {
  const section = node.closest("[data-section-id]");
  const sectionId = section?.getAttribute("data-section-id");
  if (!sectionId) return;

  const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

  try {
    const res = await fetch(url);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    return doc;
  } catch (err) {
    console.log(err);

    return null;
  }
};
